import { ChangeEvent, useEffect } from "react";
import { Box, Grid, MenuItem } from "@mui/material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { ICreateBorderoParcela } from "src/Contexts/Lancamentos/Contrato/ContratosTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";
import {
  apenasNumeros,
  FormatMoney,
  handleFormatToNumeric,
} from "src/shared/Utils/FormatMoney";
import { handleCalcAverage } from "src/shared/Utils/handleCalcAverage";

export const FormReceberParcela = () => {
  const { valuesInputsBorderoParcela, setValuesInputsBorderoParcela } =
    useContextContrato();

  const handleCalc = handleCalcAverage({
    valorTotal: Number(
      handleFormatToNumeric(valuesInputsBorderoParcela?.valor_recebido)
    ),
    porcentagem: Number(
      valuesInputsBorderoParcela?.desconto_parcela?.replace(",", ".")
    ),
    isDesconto: true,
  });

  useEffect(() => {
    setValuesInputsBorderoParcela({
      ...valuesInputsBorderoParcela,
      total_com_desconto:
        valuesInputsBorderoParcela.tipo_desconto_parcela === "PERCENTUAL"
          ? FormatMoney(String(Number(handleCalc).toFixed(2)))
          : FormatMoney(
              String(
                Number(
                  Number(
                    apenasNumeros(valuesInputsBorderoParcela.valor_recebido)
                  ).toFixed(2)
                ) -
                  Number(
                    Number(
                      apenasNumeros(valuesInputsBorderoParcela.desconto_parcela)
                    ).toFixed(2)
                  )
              )
            ),
    });
  }, [
    valuesInputsBorderoParcela.valor_recebido,
    valuesInputsBorderoParcela.desconto_parcela,
    valuesInputsBorderoParcela.tipo_desconto_parcela,
  ]);

  const handleChange =
    (prop: keyof ICreateBorderoParcela, option?: "money" | "money2") =>
    (event: ChangeEvent<HTMLInputElement>) => {
      if (option === "money") {
        setValuesInputsBorderoParcela({
          ...valuesInputsBorderoParcela,
          [prop]: FormatMoney(event.target.value),
        });
      } else if (option === "money2") {
        if (event.target.value.length <= 6) {
          setValuesInputsBorderoParcela({
            ...valuesInputsBorderoParcela,
            [prop]:
              valuesInputsBorderoParcela.tipo_desconto_parcela === "VALOR"
                ? FormatMoney(event.target.value)
                : event.target.value.replace(".", ","),
          });
        }
      } else {
        setValuesInputsBorderoParcela({
          ...valuesInputsBorderoParcela,
          [prop]: event.target.value,
        });
      }
    };

  return (
    <Box sx={{ margin: 0, padding: 0 }}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <AppTextField
            fullWidth
            label="Data recebimento *"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            type="date"
            value={valuesInputsBorderoParcela?.data_recebimento}
            variant="outlined"
            onChange={handleChange("data_recebimento")}
          />
        </Grid>
        <Grid item xs={5}>
          <AppTextField
            fullWidth
            label="Valor mensalidade *"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela?.valor_recebido}
            variant="outlined"
            onChange={handleChange("valor_recebido", "money")}
          />
        </Grid>

        <Grid item xs={3}>
          <AppTextField
            fullWidth
            label="Vidas *"
            type="number"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela.contratos_vidas}
            variant="outlined"
            onChange={handleChange("contratos_vidas")}
          />
        </Grid>

        <Grid item xs={4}>
          <AppTextField
            fullWidth
            tooltip="Desconto na parcela para calcular as comissões"
            label="Desconto"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela?.desconto_parcela}
            variant="outlined"
            onChange={handleChange("desconto_parcela", "money2")}
          />
        </Grid>
        <Grid item xs={2}>
          <AppTextField
            fullWidth
            select
            tooltip="Desconto na parcela para calcular as comissões"
            label="Desconto"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela?.tipo_desconto_parcela}
            variant="outlined"
            onChange={handleChange("tipo_desconto_parcela")}
          >
            <MenuItem value="PERCENTUAL">%</MenuItem>
            <MenuItem value="VALOR">R$</MenuItem>
          </AppTextField>
        </Grid>
        <Grid item xs={6}>
          <AppTextField
            fullWidth
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela.total_com_desconto}
            variant="outlined"
            title="Valor de base para calcular as comissões"
            disabled
          />
        </Grid>
        {/* <Grid item xs={5}>
          <AppTextField
            label="Data previsão"
            type="date"
            variant="outlined"
            value={valuesInputsBorderoParcela.data_previsao}
            onChange={handleChange("data_previsao")}
            fullWidth
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid> */}
        <Grid item xs={12}>
          <AppTextField
            fullWidth
            label="Observação"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela.observacao}
            variant="outlined"
            onChange={handleChange("observacao")}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
